import { connect } from "react-redux";

import * as _ from "lodash";
import fetch from "isomorphic-unfetch";
import { withRouter } from "next/router";

import { ROOT_URL, JOB_SEATRCH_URL, BACKEND_URL } from "../actions/types";
import Layout from "../components/Layout/Layout.react";
import Jobs from "../components/Jobs";

const JobsPage = withRouter(
  ({
    functionalArea,
    cities,
    router,
    jobs,
    totalPage,
    appliedFilters,
    functionalAreaSearch,
    title,
    description,
  }) => (
    <Layout title={title} description={description}>
      <Jobs
        cities={cities}
        functionalArea={functionalArea}
        functionalAreaSearch={functionalAreaSearch}
        jobs={jobs}
        totalPage={totalPage}
        appliedFilters={appliedFilters}
      />
    </Layout>
  )
);

JobsPage.getInitialProps = async (context) => {
  try {
    let appliedFilters = {
      keywords: context.query.keywords ? context.query.keywords.split(",") : [],
      query: context.query.query ? context.query.query : "",
      locality: context.query.locality ? context.query.locality.split(",") : [],
      salary: context.query.salary || 0,
      exp: context.query.exp || 0,
      page: context.query.page || 1,
    };

    let filterQuery = "";
    // Location based query
    let locationQuery = "";
    locationQuery = appliedFilters.locality.map((city) => `location='${city}'`);
    locationQuery = locationQuery.join(" OR ");

    if (locationQuery) {
      filterQuery = `${locationQuery} AND`;
    }

    // Functional area based query
    let functionalAreaQuery = "";
    functionalAreaQuery = appliedFilters.keywords.map(
      (keyword) => `functionalArea.secondary='${keyword}'`
    );
    functionalAreaQuery = functionalAreaQuery.join(" OR ");

    if (functionalAreaQuery) {
      filterQuery = `${filterQuery} ${functionalAreaQuery} AND`;
    }

    filterQuery = `${filterQuery} salary.min >= ${appliedFilters.salary}`;

    if (appliedFilters.exp) {
      filterQuery = `${filterQuery} AND experience.min <= ${appliedFilters.exp} AND experience.max >= ${appliedFilters.exp}`;
    }

    const searchQuery = {
      q: context.query.query ? context.query.query : "",
      limit: 15,
      offset: (appliedFilters.page - 1) * 15,
      filter: filterQuery,
      sort: ["createdAt:desc"],
    };

    // Get functional area from ATS
    let workspaceFunctional = await fetch(
      `${BACKEND_URL}/api/v1/job/functional-area-with-secondary-area/2`
    );
    workspaceFunctional = await workspaceFunctional.json();
    // TODO: Only a temporary hack to handle spelling check
    workspaceFunctional = workspaceFunctional.map((functionalArea) => ({
      id: functionalArea.id,
      name: functionalArea.name,
      icon: functionalArea.icon,
      workspaceId: functionalArea.workspaceId,
      secondaryArea: functionalArea.secodaryArea,
    }));

    let functionalAreaSearch = await fetch(`${ROOT_URL}/api/functional-area`);
    functionalAreaSearch = await functionalAreaSearch.json();
    let functionalArea = await fetch(`${ROOT_URL}/api/functional-area-filter`);
    functionalArea = await functionalArea.json();
    let cities = await fetch(`${ROOT_URL}/api/cities`);
    cities = await cities.json();
    let filteredJobs = await fetch(`${JOB_SEATRCH_URL}/indexes/jobs/search`, {
      method: "POST",
      body: JSON.stringify(searchQuery),
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer d7723c2a8b93c98d4f8dd318a936b394d24adc876fe60b7f4853bb2e82c9",
      },
    });

    filteredJobs = await filteredJobs.json();

    return {
      functionalArea: workspaceFunctional || [],
      cities: cities.success ? cities.cities : [],
      jobs: filteredJobs.hits ? filteredJobs.hits : [],
      totalPage: filteredJobs.estimatedTotalHits
        ? Math.ceil(filteredJobs.estimatedTotalHits / 15)
        : 0,
      functionalAreaSearch: functionalAreaSearch.success
        ? functionalAreaSearch.functionalArea
        : [],
      appliedFilters: appliedFilters,
      title: `Find Jobs for ${context.query.keywords || ""} ${
        context.query.locality || ""
      } Ed Tech ,Education ,Teaching | HireXL`,
      description: `Find ${context.query.keywords || ""} ${
        context.query.locality || ""
      } Jobs on hirexl.in, India’s No.1 Job Portal. Explore Thousands of Openings in your desired locations Now!`,
    };
  } catch (error) {
    console.log("job list server error", error);
    return {
      functionalArea: [],
      cities: [],
      jobs: [],
      totalPage: 0,
      functionalAreaSearch: [],
      appliedFilters: {},
      title: "Error loading jobs",
      description: "Unable to load job data",
    };
  }
};

export default JobsPage;
